export default "__VITE_ASSET__BfDtFHg9__"